var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-delete',{attrs:{"open":_vm.open,"loading":_vm.loading,"title":_vm.title,"errorMessage":_vm.errorMessage},on:{"delete":_vm.remove,"close":function($event){return _vm.$emit('close')}}},[_c('cash-register-show-data',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }